/* eslint-disable */
export const SCOPE = 'compareDrawer';
export const SELECT_FILTER_BAR_IN_COMPARE_DRAWER = `${SCOPE}SELECT_FILTER_BAR_IN_COMPARE_DRAWER`;
export const ADD_METRIC_TO_FILTER_BAR = `${SCOPE}ADD_METRIC_TO_FILTER_BAR`;
export const ADD_NEW_FILTER_BAR = `${SCOPE}ADD_NEW_FILTER_BAR`;
export const DELETE_FILTER_BAR = `${SCOPE}DELETE_FILTER_BAR`;
export const EXIT_COMPARE_MODE = `${SCOPE}EXIT_COMPARE_MODE`;
export const DELETE_SAVED_FILTER_BAR = `${SCOPE}DELETE_SAVED_FILTER_BAR`;
export const DELETE_ALL_NON_SAVED_FILTER_BARS = `${SCOPE}DELETE_ALL_NON_SAVED_FILTER_BARS`;
export const APPLY_SAVED_FILTERBARS = `${SCOPE}/APPLY_SAVED_FILTERBARS`;
